export default "__VITE_ASSET__BdB09tT8__"